import React from "react";
import { NoAccessIllustration } from "@toddle-edu/ds-theme";
import classNames from "classnames";

import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";

import classes from "./StudentBlock.scss";

const styles = {
  illustrationStyle: {
    height: 216,
    width: 288,
  },
};

const StudentBlock = props => {
  const { studentName, studentBlockMsg, t } = props;

  return (
    <div className={classes.mainContainer}>
      <img
        src={NoAccessIllustration}
        style={styles.illustrationStyle}
        alt={t("common:image_not_found")}
      />
      <div className={classes.textContainer}>
        <div className={classNames("heading-5", classes.lineHeight24)}>
          {t("common:account_access_temporarily_blocked_with_student_name", {
            studentName,
          })}
        </div>
        <div className={classNames("text-subtitle-2", classes.lineHeight24)}>
          {studentBlockMsg}
        </div>
      </div>
    </div>
  );
};

export default compose(I18nHOC({ resource: ["common"] }))(StudentBlock);
